import { useQuery } from 'react-query';
import { useSelectedAccountId } from 'hooks';
import { FEATURE_FLAGS, useConfigMatch } from '../../taboola-common-frontend-modules/account-configurations';
import { useCampaignGroupsFetchService } from '../components/EntityPicker/services/useCampaignGroupsFetchService';
import { CAMPAIGNS_GROUP_STATUS } from '../config';

export const useHasAccountCampaignGroups = () => {
    const { loadCampaignGroups } = useCampaignGroupsFetchService();
    const isMandatoryHierarchyEnabled = useConfigMatch({ [FEATURE_FLAGS.IS_MANDATORY_HIERARCHY_ENABLED]: 'true' });
    const [accountId] = useSelectedAccountId();
    const { data: hasAccountCampaignGroups, isLoading } = useQuery(
        ['hasAccountCampaignGroups', isMandatoryHierarchyEnabled, accountId],
        async () => {
            if (!isMandatoryHierarchyEnabled) {
                return false;
            }

            const [campaignsGroup, total] = await loadCampaignGroups({
                page: 1,
                pageSize: 1,
                searchText: '',
            });

            const allCampaignsGroupTerminated = campaignsGroup.every(
                campaign => campaign.status === CAMPAIGNS_GROUP_STATUS.TERMINATED
            );

            return total > 0 && !allCampaignsGroupTerminated;
        },
        {
            onError: () => false,
            placeholderData: false,
            enabled: isMandatoryHierarchyEnabled,
        }
    );
    return {
        hasAccountCampaignGroups: !!hasAccountCampaignGroups,
        isLoading,
    };
};
